import { createContext } from 'react';

export type WrapperProps = {
  open: boolean;
  onClose: () => void;
  [key: string]: unknown;
};

export type ContentProps = {
  [key: string]: unknown;
};

export interface DialogContextType {
  dialog: React.JSX.Element | null;
  content: React.JSX.Element | null;
  wrapperProps: WrapperProps;
  contentProps: ContentProps;
  showDialog: (...args: unknown[]) => void;
}

const DialogContext = createContext<DialogContextType>({
  dialog: null,
  content: null,
  wrapperProps: {} as WrapperProps,
  contentProps: {} as ContentProps,
  showDialog: () => {},
});

export default DialogContext;
